import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
import { Countdown, ScrollButton } from './Shared';
type Pack = {
  id: string;
  emoji: string;
  name: string;
  detail: string;
  oldPrice: string;
  price: string;
  checkoutUrl: string;
  bestseller?: boolean;
  savings?: string;
};
const packs: Pack[] = [{
  id: 'mat',
  emoji: '📘',
  name: 'PACK PILATES MAT',
  detail: '6 Tomos de Mat + 6 Bonus',
  oldPrice: '$26.990',
  price: '$16.990',
  checkoutUrl: 'https://profelisto.com.ar/checkouts/cn/hWNESKlUZfG2gLLlzAnIBt6A/es-ar?_r=AQABKbVQddCGBn0qwZ-Q-Q_b6_BtdVK9ixYgQGEk376uApI'
}, {
  id: 'reformer',
  emoji: '📕',
  name: 'PACK PILATES REFORMER',
  detail: '6 Tomos de Reformer + 6 Bonus',
  oldPrice: '$28.990',
  price: '$18.990',
  checkoutUrl: 'https://profelisto.com.ar/checkouts/cn/hWNESKlh0TFhJDh7naETGB3C/es-ar?_r=AQABszQLAy4RcWRvErCDYCUlE3XtXUo3d8z_O9QfZNVgMuk'
}, {
  id: 'elite',
  emoji: '🏆',
  name: 'MEGAPACK ÉLITE',
  detail: '12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE',
  oldPrice: '$49.990',
  price: '$27.990',
  bestseller: true,
  savings: 'AHORRÁS $22.000',
  checkoutUrl: 'https://profelisto.com.ar/checkouts/cn/hWNESKlxTCA14B28BR7aw3wQ/es-ar?_r=AQABtpZ8V9pve8EcfmzghhiJw-WHEl60w-JziJ4EL18Sr_U'
}];
export const Pricing = () => {
  const [selected, setSelected] = useState<string>('elite');
  const selectedPack = packs.find(p => p.id === selected)!;
  const ctaLabel = selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE' : selected === 'reformer' ? 'SÍ, QUIERO EL PACK REFORMER' : 'SÍ, QUIERO EL PACK MAT';
  return <section id="precio" className="py-20 bg-brand-charcoal scroll-mt-10" data-id="element-101" data-mp="3rzy7qudmotuz">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102" data-mp="2uhobdb2d68nq">
        {/* Header & Countdown */}
        <div className="text-center mb-12" data-id="element-103" data-mp="2zg9djg16f2et">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-104" data-mp="2rguz3btv5sco">
            ⏰ PRECIO DE LANZAMIENTO
          </h2>
          <p className="text-lg text-brand-terracotta font-bold mb-8 uppercase tracking-wider" data-id="element-105" data-mp="2mgqjdo0s51ni">
            Oferta por tiempo limitado
          </p>
          <div className="mb-6" data-id="element-106" data-mp="318in12r7or9e">
            <Countdown data-id="element-107" data-mp="2w71p9g40xkx1" />
          </div>
          <p className="text-red-300 font-medium text-sm" data-id="element-108" data-mp="2w837q5ndd9os">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* Pricing Card */}
        <div className="bg-white rounded-[28px] p-6 sm:p-10 shadow-2xl" data-id="element-109" data-mp="23jz3zpocz6oq">
          <div className="text-center mb-8" data-id="element-110" data-mp="2ifwxf06wdwx9">
            <h3 className="text-3xl sm:text-4xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-111" data-mp="2ihrfm6qsbaxn">
              Elegí tu Pack:
            </h3>
            <p className="text-gray-500 text-base sm:text-lg max-w-md mx-auto" data-id="element-112" data-mp="3tvbpbpk91yli">
              Todas las opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          {/* Pack Options */}
          <div className="space-y-4 mb-8" data-id="element-113" data-mp="aneup3bsktz">
            {packs.map(pack => {
            const isSelected = selected === pack.id;
            return <motion.button key={pack.id} type="button" onClick={() => setSelected(pack.id)} whileTap={{
              scale: 0.99
            }} className={`w-full text-left rounded-2xl border-2 transition-all p-5 sm:p-6 ${isSelected ? 'border-brand-terracotta bg-brand-cream' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-114" data-mp="5arrg4144vex">
                  <div className="flex items-center gap-4" data-id="element-115" data-mp="a9cueb7r1t72">
                    {/* Radio */}
                    <div className="flex-shrink-0" data-id="element-116" data-mp="e9d9zz6l4afp">
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-brand-terracotta' : 'border-gray-300'}`} data-id="element-117" data-mp="e8249ttkwsly">
                        {isSelected && <div className="w-3 h-3 rounded-full bg-brand-terracotta" data-id="element-118" data-mp="3f8ju27usab3n" />}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 flex items-center gap-3 sm:gap-4 min-w-0" data-id="element-119" data-mp="35aduhwwg9h1y">
                      <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-120" data-mp="318ix33hn3ntg">
                        {pack.emoji}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-121" data-mp="1ruafhnxdhi8">
                        <div className="font-bold text-brand-charcoal text-sm sm:text-base leading-tight mb-1" data-id="element-122" data-mp="3synb8ket3em8">
                          {pack.name}
                        </div>
                        {pack.bestseller && <div className="flex flex-wrap gap-1.5 my-2" data-id="element-123" data-mp="3k63l68ckyid0">
                            <span className="inline-flex items-center gap-1 bg-brand-gold text-brand-charcoal text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-124" data-mp="kjdc9l67qpio">
                              ⭐ MÁS ELEGIDO
                            </span>
                            {pack.savings && <span className="inline-block bg-brand-terracotta/10 text-brand-terracotta text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-125" data-mp="23dgaqn9t0uhr">
                                {pack.savings}
                              </span>}
                          </div>}
                        <div className="text-xs sm:text-sm text-gray-500 leading-snug" data-id="element-126" data-mp="2hdr0to3ai51v">
                          {pack.detail}
                        </div>
                      </div>
                    </div>

                    {/* Price */}
                    <div className="text-right flex-shrink-0" data-id="element-127" data-mp="2v55vwtah1wpa">
                      <div className="text-xs sm:text-sm text-gray-400 line-through leading-none mb-1" data-id="element-128" data-mp="2v7ibizsrbuz6">
                        {pack.oldPrice}
                      </div>
                      <div className={`text-xl sm:text-3xl font-bold leading-none ${isSelected ? 'text-brand-terracotta' : 'text-brand-charcoal'}`} data-id="element-129" data-mp="354datkwutzei">
                        {pack.price}
                      </div>
                    </div>
                  </div>
                </motion.button>;
          })}
          </div>

          {/* CTA Button */}
          <a href={selectedPack.checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-base sm:text-lg font-bold py-5 px-6 rounded-2xl shadow-lg shadow-brand-terracotta/30 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-3" data-id="element-130" data-mp="19yuaa1r7xu80">
            {ctaLabel}
            <ArrowRight size={20} data-id="element-131" data-mp="1sp3mm4gpz2df" />
          </a>

          <p className="text-center italic text-gray-500 text-sm mt-6 max-w-md mx-auto" data-id="element-132" data-mp="3d1n8idsgs50">
            {selected === 'elite' ? 'La opción más elegida por profesores de Pilates argentinos' : `Estás eligiendo el ${selectedPack.name.toLowerCase()} por ${selectedPack.price}`}
          </p>
        </div>

        {/* Trust Footer */}
        <div className="grid grid-cols-2 gap-y-4 gap-x-6 mt-10 max-w-md mx-auto text-white/80 text-sm" data-id="element-133" data-mp="20afmeiuaiw7q">
          <span className="flex items-center gap-2" data-id="element-134" data-mp="25991gfp86va0">
            <Lock size={16} className="text-white/60" data-id="element-135" data-mp="257xz8kbfhvl0" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-136" data-mp="1r8yazdrtvipd">
            <Zap size={16} className="text-brand-gold" data-id="element-137" data-mp="1w8ufde4ftc5g" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-138" data-mp="1w6hq0fwcnzid">
            <ShieldCheck size={16} className="text-green-400" data-id="element-139" data-mp="1hcv8u7wz7k2f" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-140" data-mp="1mbpstd6ojeo4">
            <CreditCard size={16} className="text-white/60" data-id="element-141" data-mp="3bpl2cojfmr9a" /> Tarjeta ·
            Transferencia
          </span>
        </div>
      </div>

      {/* Order Bump + Comparison on lighter background */}
      <div className="bg-brand-cream mt-20 pt-20 pb-4" data-id="element-142" data-mp="24fcccpgsq8u9">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143" data-mp="24esvlc2vtqht">
          {/* Order Bump */}
          <div className="bg-white rounded-3xl p-8 md:p-12 border border-brand-sand mb-24 shadow-sm" data-id="element-144" data-mp="1zhkdtclnboh3">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-4 text-center" data-id="element-145" data-mp="1uny70125yet7">
              ¿Qué agrega el Megapack Élite?
            </h3>
            <p className="text-center text-gray-600 mb-10" data-id="element-146" data-mp="1kruuc19oqxs0">
              Por solo unos pesos más, resolvés el año completo.
            </p>

            <div className="space-y-8 mb-10" data-id="element-147" data-mp="1go6nxlwsi88c">
              <div className="flex gap-6" data-id="element-148" data-mp="1bqeuuokesg2k">
                <div className="text-4xl" data-id="element-149" data-mp="1brg8n0st7gnz">📅</div>
                <div data-id="element-150" data-mp="16rk5t4vulva0">
                  <h4 className="text-xl font-bold text-brand-charcoal mb-2" data-id="element-151" data-mp="16sde4aaggsu9">
                    Élite 1 — El Calendario de las 1.000 Sesiones
                  </h4>
                  <p className="text-gray-600 leading-relaxed" data-id="element-152" data-mp="315lcud1jxol6">
                    La hoja de ruta de enero a diciembre. Plan de 52 semanas
                    semana a semana con exactamente qué Tomo y qué sesión dar
                    cada lunes del año. Nunca más te preguntés qué das mañana.
                  </p>
                </div>
              </div>
              <div className="h-px bg-brand-sand w-full" data-id="element-153" data-mp="3iffihn29efpz"></div>
              <div className="flex gap-6" data-id="element-154" data-mp="3nejo63pz5vbk">
                <div className="text-4xl" data-id="element-155" data-mp="3nd8mqak04znm">🔀</div>
                <div data-id="element-156" data-mp="2pqrrrbyqqy51">
                  <h4 className="text-xl font-bold text-brand-charcoal mb-2" data-id="element-157" data-mp="2prb9arkhbkij">
                    Élite 2 — Diccionario de Variaciones Infinitas
                  </h4>
                  <p className="text-gray-600 leading-relaxed" data-id="element-158" data-mp="2zopcvqlb0etf">
                    Cómo transformar 1 ejercicio en 10 versiones distintas
                    usando solo 7 variables. Tus alumnos van a creer que
                    aprendés ejercicios nuevos cada semana. 100 variaciones
                    detalladas listas para usar.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-brand-cream p-6 rounded-xl border border-brand-sand text-center italic text-lg text-brand-charcoal font-serif" data-id="element-159" data-mp="3515ht3jr0u19">
              "Por unos pesos más te llevás el año entero resuelto y clases que
              nunca se repiten. La pregunta no es si vale. Es por qué no lo
              elegiste primero."
            </div>
          </div>

          {/* Comparison Table */}
          <div data-id="element-160" data-mp="2m29p5wnjgnpj">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-161" data-mp="2m2t5xa1gd61z">
              ¿Cuánto cuesta NO tenerlo?
            </h3>
            <div className="bg-white rounded-2xl shadow-lg border border-brand-sand overflow-hidden" data-id="element-162" data-mp="2v268rjv2mwdq">
              <div className="grid grid-cols-2 bg-brand-charcoal text-white p-6" data-id="element-163" data-mp="300zlha2jajcu">
                <div className="font-bold text-lg text-center" data-id="element-164" data-mp="2zywmw1nbfhwi">
                  Sin PILATES 360
                </div>
                <div className="font-bold text-lg text-center text-brand-gold" data-id="element-165" data-mp="fas2zfcu9h27">
                  Con PILATES 360
                </div>
              </div>
              <div className="divide-y divide-brand-sand" data-id="element-166" data-mp="1zsazimmpsjpr">
                {[['Horas planificando desde cero cada semana', '5 minutos. Todo listo.'], ['Sesiones improvisadas sin progresión real', '+150 sesiones detalladas por nivel'], ['Grupos sin sistema claro', 'Estructura clara para cada nivel'], ['Siempre los mismos ejercicios', '100 variaciones listas para usar'], ['Miedo a que un alumno se lesione', 'Checklist de seguridad incluido'], ['Terminar cada clase agotada mentalmente', 'Llegás con todo resuelto'], ['Sin poder justificar un aumento de precio', 'Sistema documentado y profesional']].map((row, i) => <div key={i} className="grid grid-cols-2 p-6 hover:bg-brand-cream transition-colors" data-id="element-167" data-mp="kxkrhy3i2zxl" data-mpi={i}>
                    <div className="text-gray-600 pr-4" data-id="element-168" data-mp="1dke012n4t3i5">{row[0]}</div>
                    <div className="text-brand-charcoal font-semibold pl-4 border-l border-brand-sand flex items-center gap-3" data-id="element-169" data-mp="1ijqi7a325mee">
                      <Check className="text-green-500 flex-shrink-0" size={20} data-id="element-170" data-mp="14kqtk2fjp7i8" />{' '}
                      {row[1]}
                    </div>
                  </div>)}
              </div>
            </div>
            <p className="text-center text-xl font-serif font-bold text-brand-charcoal mt-8" data-id="element-171" data-mp="3tcbb9odtveqt">
              El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
            </p>
          </div>
        </div>
      </div>
    </section>;
};